export const GET_ORDERS = "GET_ORDERS";
export const FILTER_ORDERS = "FILTER_ORDERS";
export const ADD_ORDER = "ADD_ORDER";
export const EDIT_ORDER = "EDIT_ORDER";
export const GET_ORDER = "GET_ORDER";
export const RESET_ORDER = "RESET_ORDER";
export const ORDERS_ERROR = "ORDERS_ERROR";
